/*global _ */
import {formatDate, getDate, getDayDate, getDayDateYear, getDateTime, getDateTimeYear, time2Min} from './dates'
import {formatPrice, parseNumber, templify, fv} from './utils'
import {root as rootSettings} from './settings'

export {templify}

const formatters = {
  formatDate,
  getDate,
  getDayDate,
  getDayDateYear,
  getDateTime,
  getDateTimeYear,
  time2Min,

  formatPrice,
  parseNumber,
  templify,

  rootSettings,
}

formatters.get = _.get
formatters.kebabCase = _.kebabCase
formatters.startCase = _.startCase
formatters.first = _.head
formatters.last = _.last
formatters.join = _.join
formatters.add = _.add
formatters.divide = _.divide
formatters.floor = _.floor
formatters.max = _.max
formatters.mean = _.mean
formatters.min = _.min
formatters.multiply = _.multiply
formatters.round = _.round
formatters.subtract = _.subtract
formatters.sum = _.sum
formatters.random = _.random
formatters.pad = _.pad
formatters.padEnd = _.padEnd
formatters.padStart = _.padStart
formatters.parseInt = _.parseInt
formatters.repeat = _.repeat
formatters.replace = _.replace
formatters.snakeCase = _.snakeCase
formatters.trim = _.trim
formatters.trimEnd = _.trimEnd
formatters.trimStart = _.trimStart
formatters.truncate = _.truncate
formatters.unescape = _.unescape
formatters.escape = _.escape
formatters.upperFirst = _.upperFirst
formatters.toInteger = _.toInteger
formatters.toNumber = _.toNumber
formatters.toString = _.toString

const that = {
  $$templify: templify
}
export const format = function (value, defaultValue, config = {}, data = {}) {
  const {format = null, params = []} = config

  const me = this || that
  const allData = {...data, value}

  value = me.$$templify(value, allData)

  if (!format) {
    return fv(value, defaultValue)
  }

  const formatter = formatters[format] || me[format]
  if (_.isFunction(formatter)) {
    return formatter.call(me, value, ...(params|| []))
  }

  value = me.$$templify(format, allData)

  return value
}
export const groupFormat = function (values, defaultValue, config = {}, data = {}) {
  const {group = null, groupFormat = null, groupFormatParams: params = []} = config
  if (!group) {
    return fv(value, defaultValue)
  }
  const me = this || that

  let value = format.call(me, values, defaultValue, {format: group}, data)
  value = format.call(me, value, defaultValue, {format: groupFormat, params}, data)
  return value
}

export const valueFormat = function (value, defaultValue, config = {}, data = {}) {
  const me = this || that
  value = format.call(me, value, defaultValue, {}, data)
  if (config.group) {
    value = groupFormat.call(me, _.castArray(value), defaultValue, config, data)
  }
  const {format: template = null, formatParams: params = []} = config
  value = format.call(me, value, defaultValue, {format: template, params}, data)
  return fv(value, defaultValue)

}

formatters.format = valueFormat
formatters.groupFormat = valueFormat
formatters.valueFormat = valueFormat

export const formatNumber = function (value, format) {
  const i18n = this && this.$i18n || window.addiesaas || {}
  if (i18n && format) {
   return i18n.n(value, format)
  }
  return value
}
export const currency = function (value, format = 'currency') {
  return formatNumber.call(this, value, format)
}
export const currencyRounded = function (value, format = 'currencyRounded') {
  return currency.call(this, value, format)
}
export const formatDateTime = function (value, format) {
  const i18n = this && this.$i18n || window.addiesaas || {}
  if (i18n && format) {
   return i18n.d(value, format)
  }
  return value
}
export const shortDate = function (value) {
  return formatDateTime.call(this, value, 'short')
}
export const longDate = function (value) {
  return formatDateTime.call(this, value, 'long')
}

formatters.formatNumber = formatNumber
formatters.currency = currency
formatters.currencyRounded = currencyRounded
formatters.formatDateTime = formatDateTime
formatters.shortDate = shortDate
formatters.longDate = longDate

export default formatters
